import { useEffect, useState } from "react";
import Analytics from "../extras/Analytics";
import Title from "../extras/Title";
import { useDispatch, useSelector } from "react-redux";
import { getWalletData } from "../../redux/slice/userSlice";
import Table from "../extras/Table";
import Pagination from "../extras/Pagination";
import Sign from "../../assets/images/sign.png"
import { ReactComponent as Delievered } from "../../assets/icon/deliever.svg"
import { ReactComponent as WithDraw } from "../../assets/icon/wit.svg"
import { ReactComponent as Cancel } from "../../assets/icon/cancel.svg"
import { ReactComponent as Refund } from "../../assets/icon/refund.svg"
import { IconPlus } from "@tabler/icons-react";

const Recharge = () => {
    const transactionTypeData = [
        { value: "1", label: "Credit" },
        { value: "2", label: "Debit" }
    ]
    const { walletData, total } = useSelector((state) => state.user);

    const [transactionType, setTransactionType] = useState("All");
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const dispatch = useDispatch()
    const { setting } = useSelector((state) => state.setting)

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event, 10));
        setPage(0);
    };

    const [startDate, setStartDate] = useState("ALL");
    const [endDate, setEndDate] = useState("ALL");
    useEffect(() => {
        const payload = {
            startDate: startDate === "ALL" ? "All" : startDate,
            endDate: endDate === "ALL" ? "All" : endDate,
            start: page,
            limit: rowsPerPage,
            type: transactionType
        }
        dispatch(getWalletData(payload))
    }, [page, rowsPerPage, startDate, transactionType])

    const walletTable = [
        {
            Header: "No",
            Cell: ({ index }) => (
                <span>{page * rowsPerPage + parseInt(index) + 1}</span>
            ),
        },
       
        {
            Header: "User Info",
            Cell: ({ row }) => (
                <span
                    className="text-capitalize  cursor"

                >
                    {row?.user?.fname + "" + row?.user?.lname || "-"}
                </span>
            ),
        },
         {
            Header: "UniqueId",
            Cell: ({ row }) => (
                <span
                    className="text-capitalize  cursor"

                >
                    {row?.uniqueId || "-"}
                </span>
            ),
        },
        {
            Header: `Amount (${setting?.currencySymbol || "$"})`,
            Cell: ({ row }) => (
                <span
                    className="text-capitalize  cursor"

                >
                    {row?.amount || "-"}
                </span>
            ),
        },
        {
            Header: "Date",
            Cell: ({ row }) => (
                <span
                    className="text-capitalize  cursor"

                >
                    {row?.date
                        ? row?.date
                        : "-"}
                </span>
            ),
        },
        {
            Header: "Time",
            Cell: ({ row }) => (
                <div>
                    {row?.time ? row?.time : "-"}
                </div>
            ),
        },
        {
            Header: "Transaction Type",
            Cell: ({ row }) =>
                row?.type === 1 ? (
                    <button className=" badge-success ">
                        Credit
                    </button>
                ) : row?.type === 2 || row?.type === 3 ? (
                    <button className="badge-danger" >
                        Debit
                    </button>
                ) : row?.type === 4 ? (
                    <button  className="badge-danger"  >
                        Debit
                    </button>
                ) : row?.type === 5 ? (
                    <button  className="badge-success"  >
                        Credit
                    </button>
                ) : row?.type === "All" ? (
                    <button
                         className="badge-primary" 
                    >
                        All
                    </button>
                ) : (
                    ""
                ),
        },
        {
            Header: "Transaction Completed",
            Cell: ({ row }) =>
                row?.type === 1 ? (
                    <button className="badge badge-success p-2"
                        >
                        
                        Wallet Deposit
                    </button>
                ) : row?.type === 2 ? (
                    <button
                        className="badge badge-danger p-2"
                        
                    >
                        
                        Booking Fee Deduction
                    </button>
                ) : row?.type === 3 ? (

                    <button className="badge badge-danger p-2"
                       >
                        
                       Product Purchase Deduction
                    </button>
                ) : row?.type === 4 ? (
                    <button className="badge badge-danger p-2"
                       >
                        {/* <Cancel /> */}
                        Order Cancellation Fee
                    </button>
                ) : row?.type === 5 ? (
                    <button className="badge badge-success p-2"
                        >
                        Order Refund
                    </button>
                ) : (
                    ""
                ),
        },
    ];
    return (
        <>
            <div className="userPage">
            <div className="d-flex justify-content-end mb-3">
                <Analytics
                            analyticsStartDate={startDate}
                            analyticsStartEnd={endDate}
                            placeholder="Wallet"
                            analyticsStartDateSet={setStartDate}
                            analyticsStartEndSet={setEndDate}
                        />
            </div>
            <div className="user-table mb-3">
            <div className="user-table-top">
                      <div className=" d-flex justify-content-between align-items-center w-100 ">
                        <div className="w-100">
                          <h5
                            className="main-title">
                            Wallet History
                          </h5>
                        </div>
                        <div className="d-flex gap-2 justify-content-end w-100">
                            <div className="inputData w-25">
                        
                        <select
                            name="transactionType"
                            className="form-select "
                            id="transactionType"
                            value={transactionType}
                            onChange={(e) => {
                                console.log("eeeeee", e)
                                const selectedSalonId = e.target.value;
                                const payload = {
                                    startDate: startDate === "ALL" ? "All" : startDate,
                                    endDate: endDate === "ALL" ? "All" : endDate,
                                    start: page,
                                    limit: rowsPerPage,
                                    type: selectedSalonId
                                }
                                setTransactionType(selectedSalonId);
                                dispatch(getWalletData(payload))
                            }}
                        >
                            <option key="All" value="All">
                                All
                            </option>
                            {transactionTypeData?.map((data) => (
                                <option key={data?.value} value={data?.value}>
                                    {data?.label}
                                </option>
                            ))}
                        </select>
                    </div>
                        </div>
                      </div>
                    </div>
                {/* <div className="row">
                    <Title name="Wallet History" className="mt-4" />
                </div> */}
                

                <Table
                    data={walletData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    mapData={walletTable}
                />
                <Pagination
                    type={"server"}
                    serverPage={page}
                    setServerPage={setPage}
                    serverPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    totalData={total}
                />
            </div>
            </div>
        </>
    )
}
export default Recharge;